import {PaginationProperties} from '../pagination.properties';

const paginationObject: PaginationProperties = new PaginationProperties();

const USER: string = 'Janssen, Jan';
const PUBLISHING: string =  'publishing';
const NOT_PUBLISHING: string = 'not publishing';
const PUBLISHING_OFF: string = 'publishing off';
const PUBLISHING_ON: string = 'publishing on';

paginationObject.setDisplayedData([[
  {
    user: USER,
    actionTaken: NOT_PUBLISHING,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-03T00:23:32+02:00',
    timeString: '00:23',
  },
  {
    user: USER,
    actionTaken:  PUBLISHING,
    reason: PUBLISHING_ON,
    actionTime: '2018-05-03T00:06:25+02:00',
    timeString: '00:06',
  },
  {
    user: USER,
    actionTaken: NOT_PUBLISHING,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-02T14:21:34+02:00',
    timeString: '14:21',
  },
  {
    user: USER,
    actionTaken:  PUBLISHING,
    reason: PUBLISHING_ON,
    actionTime: '2018-05-02T14:20:47+02:00',
    timeString: '14:20',
  },
  {
    user: USER,
    actionTaken: NOT_PUBLISHING,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-02T14:19:37+02:00',
    timeString: '14:19',
  },
  {
    user: USER,
    actionTaken:  PUBLISHING,
    reason: PUBLISHING_ON,
    actionTime: '2018-05-02T14:15:22+02:00',
    timeString: '14:15',
  },
  {
    user: USER,
    actionTaken: NOT_PUBLISHING,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-02T14:09:29+02:00',
    timeString: '14:09',
  },
  {
    user: USER,
    actionTaken: PUBLISHING_ON,
    reason: PUBLISHING_ON,
    actionTime: '2018-05-01T23:53:06+02:00',
    timeString: '23:53',
  },
  {
    user: USER,
    actionTaken: PUBLISHING_OFF,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-01T23:51:42+02:00',
    timeString: '23:51',
  },
  {
    user: USER,
    actionTaken: PUBLISHING_ON,
    reason: PUBLISHING_ON,
    actionTime: '2018-05-01T23:51:18+02:00',
    timeString: '23:51',
  },
]]);
paginationObject.setPages([0, 1]);
paginationObject.setPage(0);
paginationObject.setMaxPage(2);
paginationObject.setFilteredData([[
  {
    user: USER,
    actionTaken: NOT_PUBLISHING,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-03T00:23:32+02:00',
    timeString: '00:23',
  },
  {
    user: USER,
    actionTaken:  PUBLISHING,
    reason: PUBLISHING_ON,
    actionTime: '2018-05-03T00:06:25+02:00',
    timeString: '00:06',
  },
  {
    user: USER,
    actionTaken: NOT_PUBLISHING,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-02T14:21:34+02:00',
    timeString: '14:21',
  },
  {
    user: USER,
    actionTaken:  PUBLISHING,
    reason: PUBLISHING_ON,
    actionTime: '2018-05-02T14:20:47+02:00',
    timeString: '14:20',
  },
  {
    user: USER,
    actionTaken: NOT_PUBLISHING,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-02T14:19:37+02:00',
    timeString: '14:19',
  },
  {
    user: USER,
    actionTaken:  PUBLISHING,
    reason: PUBLISHING_ON,
    actionTime: '2018-05-02T14:15:22+02:00',
    timeString: '14:15',
  },
  {
    user: USER,
    actionTaken: NOT_PUBLISHING,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-02T14:09:29+02:00',
    timeString: '14:09',
  },
  {
    user: USER,
    actionTaken: PUBLISHING_ON,
    reason: PUBLISHING_ON,
    actionTime: '2018-05-01T23:53:06+02:00',
    timeString: '23:53',
  },
  {
    user: USER,
    actionTaken: PUBLISHING_OFF,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-01T23:51:42+02:00',
    timeString: '23:51',
  },
  {
    user: USER,
    actionTaken: PUBLISHING_ON,
    reason: PUBLISHING_ON,
    actionTime: '2018-05-01T23:51:18+02:00',
    timeString: '23:51',
  },
  {
    user: USER,
    actionTaken: PUBLISHING_OFF,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-01T23:49:34+02:00',
    timeString: '23:49',
  },
  {
    user: USER,
    actionTaken: PUBLISHING_ON,
    reason: PUBLISHING_ON,
    actionTime: '2018-05-01T23:48:14+02:00',
    timeString: '23:48',
  },
  {
    user: USER,
    actionTaken: PUBLISHING_OFF,
    reason: PUBLISHING_OFF,
    actionTime: '2018-05-01T23:48:04+02:00',
    timeString: '23:48',
  },
]]);
paginationObject.setIsNextButtonDisabled(false);
paginationObject.setIsPreviousButtonDisabled(true);
paginationObject.setSteps([10, 20, 50, 100]);
paginationObject.setStep(10);

export { paginationObject };
